import React from 'react';
import { useState, useEffect } from 'react' 
import { Link } from 'react-router-dom';
import { db } from '../../../../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot } from 'firebase/firestore';

const Python = ({portfolioData}) => {   
    return (
        <>
            <div className="page-hd clearfix">
                <div className="left-float" style={{marginTop: "0px", marginRight: "20px"}}>
                    <img src="/images/skin1/python-logo.png" /> 
                </div>
                <div className="left-float" style={{marginTop: "10px"}}>
                    <p><strong>Experience: 2 Years</strong></p>
                    <p><strong></strong></p>
                </div>
            </div>
                <ul>
                <li>- Experienced in writing Python programs to automate work flows.</li>
                <li>- Extensively worked on Django framework as a middleware to support webapplications and mobile applications.</li>
                <li>- Worked on Web scraping to collect data and save it in database.</li> 
            </ul>
            <h3>Python Projects</h3> 
            <ul>
                <li><a href="https://moboo.com">MoBoo</a></li>
                <li><a href="https://childrenslit.com">ChildrensLit</a></li>
            </ul>
             
        </>
        
    )

}
export default Python;